const SDK_VERSION = "11.11.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
